module.exports = __webpack_public_path__ + "static/media/workPvcCoatings6.ad16aa55.jpg";